import loadable from '@loadable/component';
import LoadingComponent from 'components/Loaders/LoadingComponent';

const ParcelsUndeliverableLoadable = loadable(
  () => import(/* webpackChunkName: 'admin-undeliverable' */ './ParcelsUndeliverable'),
  {
    fallback: <LoadingComponent />,
  }
);

export default ParcelsUndeliverableLoadable;
